export default __webpack_public_path__ + "static/media/bg-polinter-plastics.e64f0cb1.jpg";